interface PartnerUserDetailsRequestOptions {
    method: string;
    body: string;
    headers: Record<string, string>;
}

const getPartnerUserDetailsApiAddress = () =>
    window.dazn.startupData.ServiceDictionary.PartnerUserDetails.Versions.v1
        .ServicePath;

function getPartnerUserDetailsPayload(
    responseCode: string,
    isAmazonLp: boolean
): PartnerUserDetailsRequestOptions {
    const getClientdId = (): string =>
        window.dazn.features.getVariableStringAnonymous(
            'f_ar_landingpages_showlwapage',
            'ClientID'
        ) ?? 'amzn1.application-oa2-client.f0b29fe5c2e44e3e836b1edf7af6b731';

    const createRequestBody = (): Record<string, any> => {
        const commonBody = {
            idpType: 'idp-partner-token',
            idpMetadata: {
                version: 1
            }
        };

        return isAmazonLp
            ? {
                ...commonBody,
                idpMetadata: {
                    ...commonBody.idpMetadata,
                    partnerName: 'amazon'
                },
                idpPayload: {
                    code: responseCode,
                    clientId: getClientdId()
                }
            }
            : {
                ...commonBody,
                idpMetadata: {
                    ...commonBody.idpMetadata,
                    partnerName: 'canal-plus'
                },
                idpPayload: {
                    code: responseCode
                }
            };
    };

    const headers = {
        'Content-Type': 'application/json',
        ...(window.dazn.devMode.isDevModeEnabled && {
            'x-dazn-marco': '',
            'x-dazn-device': window.dazn.device.guid
        })
    };

    return {
        method: 'POST',
        body: JSON.stringify(createRequestBody()),
        headers
    };
}

export { getPartnerUserDetailsPayload, getPartnerUserDetailsApiAddress };
